import styled from 'styled-components'
import { BasicButton } from '@sevenrooms/ui-kit/form'
import { Window, Modal, ModalBody, ModalHeader, ModalTitle, ModalFooter, Flex, ImagesCarousel } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import type { PropsWithChildren } from 'react'

const IMAGE_HEIGHT = '270px'

interface DetailsModalProps {
  title: string
  modalAriaLabel: string
  imageUrls?: string[]
  onClose: () => void
}

export const DetailsModal = ({ title, modalAriaLabel, imageUrls, onClose, children }: PropsWithChildren<DetailsModalProps>) => (
  <Window active>
    <Modal ariaLabel={modalAriaLabel} width="100%" maxHeight="90%">
      <ModalHeader onClose={onClose}>
        <ModalTitle title={title} />
      </ModalHeader>
      <ModalBody>
        <Text textStyle="body1">
          {imageUrls && imageUrls.length > 0 && (
            <Flex alignItems="center" justifyContent="center" borderRadius="s" overflow="hidden">
              {imageUrls && imageUrls.length > 0 && <ImagesCarousel images={imageUrls} height={IMAGE_HEIGHT} />}
            </Flex>
          )}
          {children}
        </Text>
      </ModalBody>
      <ModalFooter>
        <StyledBackButton onClick={onClose}>Back</StyledBackButton>
      </ModalFooter>
    </Modal>
  </Window>
)

const { color_primary: colorPrimary, fonts_color_button: fontsColorButton } = window.widgetInit.settings

export const StyledImage = styled.img`
  object-fit: cover;
  object-position: center center;
  width: 100%;
  max-height: 270px;
`

const StyledBackButton = styled(BasicButton)`
  width: 100%;
  height: 57px;
  padding: 0 28px;
  border-radius: 6px;
  background-color: ${colorPrimary};
  color: ${fontsColorButton};
  user-select: none;
  :focus-visible {
    opacity: 0.8;
    outline: 5px auto Highlight;
    outline: -webkit-focus-ring-color auto 1px;
  }
`
